module.exports = __webpack_public_path__ + "images/logos/merz-white.svg";